module.exports = __webpack_public_path__ + "img/logo-big-landing.62ede8a7.svg";